// extracted by mini-css-extract-plugin
export var categories = "sectionCategoryList-module--categories--dd31f";
export var category = "sectionCategoryList-module--category--a983e";
export var richtext = "sectionCategoryList-module--richtext--c3fd0";
export var section = "sectionCategoryList-module--section--ca28e";